import HeroSection from "@/components/HeroSection";
import FeaturedOfferBanner from "@/components/FeaturedOfferBanner";
import PillarsSection from "@/components/PillarsSection";
import MethodTimeline from "@/components/MethodTimeline";
import DiagnosticSection from "@/components/DiagnosticSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import CTAFinal from "@/components/CTAFinal";
import { useEffect, useState } from "react";
import { fetchProducts } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { BOUTIQUE_ENABLED } from "@/lib/features";

function BoutiquePreview() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    fetchProducts().then((p) => setProducts(p.slice(0, 6))).catch(() => {});
  }, []);
  return (
    <section className="bg-pearl py-24 sm:py-32" data-testid="boutique-preview">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12 items-end">
          <div className="md:col-span-7">
            <div className="font-mono-overline text-mute mb-3">Boutique</div>
            <h2 className="font-serif text-4xl sm:text-5xl leading-[1.05] tracking-tight">
              Des outils concrets. <em className="text-mute not-italic font-light">Applicables demain.</em>
            </h2>
          </div>
          <div className="md:col-span-5 md:text-right">
            <Link to="/boutique" className="inline-flex items-center gap-2 text-sm font-medium border-b border-ink pb-0.5 hover:gap-3 transition-all" data-testid="boutique-preview-cta">
              Voir tous les produits <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((p) => (
            <ProductCard key={p.slug} product={p} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default function HomePage() {
  useDocumentTitle(null, "ShinRai Consulting — La méthode tri-disciplinaire (Lean, Neurosciences, IA) pour dirigeants qui veulent reprendre le pilotage de leur organisation. Interventions dans le monde entier.");
  return (
    <main data-testid="home-page">
      <HeroSection />
      <FeaturedOfferBanner />
      <PillarsSection />
      {BOUTIQUE_ENABLED && <BoutiquePreview />}
      <MethodTimeline />
      <DiagnosticSection />
      <TestimonialsSection />
      <FAQSection />
      <CTAFinal />
    </main>
  );
}
